import React from "react";
import ErrorPage from "./ErrorPage";

function Page403() {

  return <ErrorPage code="403" title="Oops! Forbidden ;(" message="접근할 수 없는 페이지입니다." />;
}

export default Page403;
